/**
 * Color token definitions based on the design system
 */

export const colors = {
  // Base colors
  brand: {
    25: 'hsl(var(--brand-25))',
    50: 'hsl(var(--brand-50))',
    100: 'hsl(var(--brand-100))',
    200: 'hsl(var(--brand-200))',
    300: 'hsl(var(--brand-300))',
    400: 'hsl(var(--brand-400))',
    500: 'hsl(var(--brand-500))',
    600: 'hsl(var(--brand-600))',
    700: 'hsl(var(--brand-700))',
    800: 'hsl(var(--brand-800))',
    900: 'hsl(var(--brand-900))',
    950: 'hsl(var(--brand-950))',
  },
  error: {
    25: 'hsl(var(--error-25))',
    50: 'hsl(var(--error-50))',
    100: 'hsl(var(--error-100))',
    200: 'hsl(var(--error-200))',
    300: 'hsl(var(--error-300))',
    400: 'hsl(var(--error-400))',
    500: 'hsl(var(--error-500))',
    600: 'hsl(var(--error-600))',
    700: 'hsl(var(--error-700))',
    800: 'hsl(var(--error-800))',
    900: 'hsl(var(--error-900))',
    950: 'hsl(var(--error-950))',
  },
  warning: {
    25: 'hsl(var(--warning-25))',
    50: 'hsl(var(--warning-50))',
    100: 'hsl(var(--warning-100))',
    200: 'hsl(var(--warning-200))',
    300: 'hsl(var(--warning-300))',
    400: 'hsl(var(--warning-400))',
    500: 'hsl(var(--warning-500))',
    600: 'hsl(var(--warning-600))',
    700: 'hsl(var(--warning-700))',
    800: 'hsl(var(--warning-800))',
    900: 'hsl(var(--warning-900))',
    950: 'hsl(var(--warning-950))',
  },
  success: {
    25: 'hsl(var(--success-25))',
    50: 'hsl(var(--success-50))',
    100: 'hsl(var(--success-100))',
    200: 'hsl(var(--success-200))',
    300: 'hsl(var(--success-300))',
    400: 'hsl(var(--success-400))',
    500: 'hsl(var(--success-500))',
    600: 'hsl(var(--success-600))',
    700: 'hsl(var(--success-700))',
    800: 'hsl(var(--success-800))',
    900: 'hsl(var(--success-900))',
    950: 'hsl(var(--success-950))',
  },
  gray: {
    25: 'hsl(var(--gray-25))',
    50: 'hsl(var(--gray-50))',
    100: 'hsl(var(--gray-100))',
    200: 'hsl(var(--gray-200))',
    300: 'hsl(var(--gray-300))',
    400: 'hsl(var(--gray-400))',
    500: 'hsl(var(--gray-500))',
    600: 'hsl(var(--gray-600))',
    700: 'hsl(var(--gray-700))',
    800: 'hsl(var(--gray-800))',
    900: 'hsl(var(--gray-900))',
    950: 'hsl(var(--gray-950))',
  },
  
  // Semantic tokens
  text: {
    primary: 'hsl(var(--foreground))',
    secondary: 'hsl(var(--muted-foreground))',
    tertiary: 'hsl(var(--muted-foreground))',
    disabled: 'hsl(var(--muted-foreground))',
    brand: 'hsl(var(--brand-700))',
    'on-brand': 'hsl(var(--brand-50))',
    error: 'hsl(var(--error-600))',
    warning: 'hsl(var(--warning-600))',
    success: 'hsl(var(--success-600))',
  },
  background: {
    primary: 'hsl(var(--background))',
    secondary: 'hsl(var(--secondary))',
    tertiary: 'hsl(var(--muted))',
    brand: 'hsl(var(--brand-50))',
    error: 'hsl(var(--error-50))',
    warning: 'hsl(var(--warning-50))',
    success: 'hsl(var(--success-50))',
    card: 'hsl(var(--card))',
  },
  border: {
    primary: 'hsl(var(--border))',
    secondary: 'hsl(var(--input))',
    tertiary: 'hsl(var(--accent))',
    brand: 'hsl(var(--brand-300))',
    error: 'hsl(var(--error-300))',
    warning: 'hsl(var(--warning-300))',
    success: 'hsl(var(--success-300))',
  },
  focus: {
    ring: 'hsl(var(--ring))',
    brand: 'hsl(var(--brand-500))',
    error: 'hsl(var(--error-500))',
    warning: 'hsl(var(--warning-500))',
    success: 'hsl(var(--success-500))',
  },
  
  // Component-specific
  button: {
    primary: {
      bg: 'hsl(var(--brand-600))',
      text: 'white',
      hover: 'hsl(var(--brand-700))',
      focus: 'hsl(var(--brand-500))',
    },
    secondary: {
      bg: 'transparent',
      text: 'hsl(var(--brand-700))',
      border: 'hsl(var(--brand-300))',
      hover: 'hsl(var(--brand-50))',
      focus: 'hsl(var(--brand-500))',
    },
    tertiary: {
      bg: 'transparent',
      text: 'hsl(var(--brand-700))',
      hover: 'hsl(var(--brand-50))',
      focus: 'hsl(var(--brand-500))',
    },
  },
};

export type Colors = typeof colors;